export default {"src":"/newStatic/_next/static/media/bitbns-academy.d615193c.svg","height":26,"width":24};